class ProductAlternative {
  constructor() {
    this.section = document.getElementById('template-product');
    this.sectionId = this.section.getAttribute('data-section-id');
    this.hiddenInput = document.querySelector('.hiddenSelectedId');
    this.init();
  }
  init() {
    this.addEventListeners();
    this.fetchUpdatedSection();
  }
  handleResponse() {
    if (this.status === 200) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.responseText, 'text/html');
      const alternativeMessageElement = doc.getElementById('product-alternative-message');
      if (alternativeMessageElement) {
        const currentAlternativeMessage = document.getElementById('product-alternative-message');
        if (currentAlternativeMessage) {
          currentAlternativeMessage.style.opacity = '0';
          setTimeout(() => {
            currentAlternativeMessage.innerHTML = alternativeMessageElement.innerHTML;
            currentAlternativeMessage.style.opacity = '1';
          }, 300);
        } else {
          console.error('Element product-alternative-message not found in current DOM');
        }
      } else {
        console.error('Element product-alternative-message not found in response');
      }
    } else {
      console.error('Invalid response, status:', this.status);
    }
  }
  fetchUpdatedSection() {
    const request = new XMLHttpRequest();
    const currentUrl = new URL(window.location.href);
    const variantId = this.hiddenInput.value;
    currentUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', currentUrl);
    request.addEventListener('load', this.handleResponse);
    request.addEventListener('error', e => console.error('Request error:', e));
    request.addEventListener('abort', () => console.warn('Request aborted'));
    currentUrl.searchParams.set('section_id', this.sectionId);
    request.open('GET', currentUrl.toString(), true);
    request.send();
  }
  addEventListeners() {
    const optionSelectors = document.querySelectorAll('[data-single-option-selector]');
    optionSelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        setTimeout(() => this.fetchUpdatedSection(), 100);
      });
    });
  }
}
new ProductAlternative();
theme.ProductAlternative = ProductAlternative;